export default __webpack_public_path__ + "static/media/Scholarship_bg.49488135.jpeg";